module.exports = __webpack_public_path__ + "images/color-fun-2-4568c0e44d8746af6c26799a8d003ffc.jpg";